<template>
  <div class="report-filter report-performer">
    <div class="ms-help">Исполнитель:</div>
    <i-select v-model="performer" style="width: 160px" filterable>
      <i-option
        v-for="item in companies"
        :value="item.id"
        :label="`${item.name}`"
        :key="item.id"
      >
        <span class="report-performer__option">
          {{ item.name }}
        </span>
      </i-option>
    </i-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      companies: [{ id: 'all', name: 'Все' }]
    }
  },
  computed: {
    performer: {
      get () {
        return this.$store.state.reports.performer
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'performer',
          value
        })
      }
    }
  },
  async created () {
    try {
      const url = `page/other_company?order=code_asc`
      const data = await this.$store.dispatch('GET_REQUEST', { url })

      this.companies = [
        { id: 'all', name: 'Все' },
        ...data
      ]
    } catch (error) {
      console.log(error)
    }
  }
}
</script>

<style lang="less">
.report-performer {
  display: flex;
  align-items: center;

  .ms-help {
    margin-right: 8px;
  }

  &__option {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 720px;
  }
}
</style>
